import { DateTime } from 'luxon'

import { isAwaitingWithdrawal } from './allowance'
import { sortRewardRequests } from './sortRewardRequests'

// Separa os resgates do usuário em duas listas, cada uma já ordenada:
// - toWithdraw: aprovados dentro do prazo (aba "A retirar", acionáveis)
// - history: retirados, expirados e reembolsados (aba "Histórico", read-only)
export const partitionRewardRequests = (
  rewardRequests = [],
  now = DateTime.now()
) => {
  const toWithdraw = []
  const history = []

  for (const request of rewardRequests) {
    if (isAwaitingWithdrawal(request, now)) toWithdraw.push(request)
    else history.push(request)
  }

  return {
    toWithdraw: sortRewardRequests(toWithdraw, now),
    history: sortRewardRequests(history, now)
  }
}
